//
//
//
//
//
//
//
//
//
//
//
//
//
import Box from "./vnp-input-box";
import Keyboard from "./vnp-keyboard";
export default {
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  components: {
    'vnp-input-box': Box,
    'vnp-keyboard': Keyboard
  },
  data: function data() {
    return {
      show: false
    };
  },
  computed: {
    val: {
      set: function set(v) {
        this.$emit("input", v);
      },
      get: function get() {
        return this.value;
      }
    }
  }
};